import { render } from "./SavedListingsPage.vue?vue&type=template&id=59179fd0&scoped=true"
import script from "./SavedListingsPage.vue?vue&type=script&lang=js"
export * from "./SavedListingsPage.vue?vue&type=script&lang=js"

import "./SavedListingsPage.vue?vue&type=style&index=0&id=59179fd0&lang=css"
import "./SavedListingsPage.vue?vue&type=style&index=1&id=59179fd0&lang=css"
import "./SavedListingsPage.vue?vue&type=style&index=2&id=59179fd0&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59179fd0"]])

export default __exports__